import { ColorObject, hslToRgb, recomposeColor } from '@mui/material';
import { decomposeColor } from '@mui/system/colorManipulator/colorManipulator';
import * as _ from 'lodash';
import { useState } from 'react';
import { theme } from '../theme/theme.ts';

export const useColorWheel = () => {
  const [initialColor] = useState<ColorObject>(
    decomposeColor(theme.palette.primary.main),
  );

  const colors = [
    '#6699AB',
    '#EEE7D6',
    '#AFC33C',
    '#097E71',
    '#d4A0A7',
    '#A9C4AB',
    '#E3B505',
    '#F2D1A6',
    '#B8A269',
    '#85B5BE',
    '#F28C28',
    '#F25764',
    '#956D91',
    '#7DDEF3',
  ] as const;

  const [wheel] = useState<string[]>(() => {
    const startingHue = 45;

    return _.times(35).map((i) => {
      const nextHue = Math.max(startingHue, (startingHue + (i + 1) * 57) % 190);
      const nextSaturation = Math.floor(Math.random() * 10 + 30);
      const nextLightness = 50;
      return hslToRgb(`hsl(${nextHue}, ${nextSaturation}, ${nextLightness}%)`);
    });
  });

  return {
    getColor: (index: number) => {
      if (index < colors.length) {
        return colors[index];
      } else {
        return wheel[index] ?? recomposeColor(initialColor);
      }
    },
  };
};
